const placeholderDefault = {
  id: null,
  locationId: null,
  eventId: null,
  date: null,
  time: null,
  covers: null,
  recordLockExpiration: null,
  recordLockKey: null
}

export default {
  data: function () {
    return {
      loadingPlaceholder: false,
      reservationPlaceholder: placeholderDefault,
      lastPlaceholderHash: null,
      reloadPlaceholder: false
    }
  },
  computed: {
    isPlaceholder () {
      return this.isNewItem && !!this.itemData.id
    }
  },
  methods: {
    doRenewLock (success, fail) {
      const isCancelled = !!this.itemData.cancelled || !!(this.originalItem || {}).cancelled
      if (this.isPlaceholder && !isCancelled) {
        // New reservation
        this.lastPlaceholderHash = null
        this.reservationPlaceholder = placeholderDefault
        this.itemData.id = null
        this.setRecordLocksInObject(this.itemData, this.itemData.recordLockKey, null, null)
        if (this.selectedSeatingTime) {
          // Have valid seating time.  Get new placeholder
          this.getPlaceHolder(success, fail)
        } else {
          // No valid seating time. Just clear the placeholder
          success()
        }
      } else {
        // Editing existing reservation
        if (!isCancelled) {
          // Try to re-lock record, then update placeholder
          this.doRenewLockCore(() => {
            this.getPlaceHolder(success, (e) => {
              success()
              this.apiResourceError(e)
            })
          }, fail)
        } else {
          // Cancelled record.  Just renew lock.  No placeholder
          this.doRenewLockCore(success, fail)
        }
      }
    },
    placeHolderCommand (success, fail) {
      var fieldErrorHandler = () => {}
      // if (!fail) {
      //   fail = this.apiItemError
      //   fieldErrorHandler = this.setFieldError
      // }
      fieldErrorHandler = this.setFieldError
      fail = this.apiItemError
      return {
        command: 'diningReservationPlaceholder',
        load: (r) => {
          // Get placeholder from result
          const newPlaceHolder = r[0]
          const itemData = this.itemData
          console.warn('Setting Placeholder', newPlaceHolder, itemData)
          // Record our placeholder
          this.reservationPlaceholder = newPlaceHolder
          const isDirty = this.isDirty
          // Change reservation configuration based on placeholder
          itemData.id = newPlaceHolder.id

          itemData.isPlaceHolder = newPlaceHolder.isPlaceHolder
          if (newPlaceHolder.recordLockExpiration) {
            this.setRecordLocksInObject(this.itemData, this.itemData.recordLockKey, newPlaceHolder.recordLockKey, newPlaceHolder.recordLockExpiration)
          }
          const cancelledDetailsMap = this.itemData.cancelledDetails.reduce((o, d) => {
            o[d.id] = d
            return o
          }, {})
          const selectedCovers = newPlaceHolder.newPlaceHolderDetails.filter(d => !cancelledDetailsMap[d.id])
          if (selectedCovers.length > this.itemData.details.length && selectedCovers.length <= this.partySize) {
            this.partySize = selectedCovers.length
          }
          if (newPlaceHolder.tableAssignmentWarning) {
            this.setFieldError({
              name: 'tableAssignments',
              path: '$[0]',
              index: 0,
              status: newPlaceHolder.tableAssignmentWarning
            })
          }
          // If we have new placeholders.  Update the IDs for them
          setTimeout(() => {
            const oldDetails = this.itemData.details
            var newPlaceHolderDetails = newPlaceHolder.newPlaceHolderDetails
            // Create map of new placeholder ids
            const newPlaceHolderIds = newPlaceHolderDetails.reduce((o, d) => {
              o[d.id] = true
              return o
            }, {})
            // Clear out old placeholder ids
            oldDetails.filter(d => {
              if (!newPlaceHolderIds[d.id] && d.isPlaceholder) {
                // Placeholder Id doesn't exist
                d.id = null
              }
            })
            // Create map of existing details ids
            const usedIds = oldDetails.reduce((o, d) => {
              if (d.id) o[d.id] = true
              return o
            }, {})
            // Loop over details that don't yet have an id
            for (let detail of oldDetails.filter(d => !d.id)) {
              // Filter placeholder details that we haven't yet used
              newPlaceHolderDetails = newPlaceHolderDetails.filter(d => !usedIds[d.id] && d.isPlaceholder)
              // Get first unused placeholder detail
              const newDetailPlaceholder = newPlaceHolderDetails.find(d => d.id)
              if (newDetailPlaceholder) {
                // Use that placeholder
                const newId = newDetailPlaceholder.id
                usedIds[newId] = true
                detail.id = newId
                detail.isPlaceholder = newDetailPlaceholder.isPlaceholder
                detail.recordLockKey = newDetailPlaceholder.recordLockKey
                detail.recordLockExpiration = newDetailPlaceholder.recordLockExpiration
                detail.reservationId = newDetailPlaceholder.reservationId
              }
            }
            itemData.tableAssignments = newPlaceHolder.tableAssignments // .splice(0, newPlaceHolder.tableAssignments.length, ...newPlaceHolder.tableAssignments)
          }, 0)
          // Reset isDirty flag
          this.resetDirty(isDirty)
          // Refresh seating times to include our placeholder counts
          this.loadSeatingTimes()
          success()
        },
        error: fail,
        fieldError: fieldErrorHandler,
        loading: this.setIsLoading
      }
    },
    getPlaceHolder (success = () => {}, fail = false) {
      // console.log('Loading place holder...')
      if (!fail) {
        fail = function (r) {
          console.error('Failed Loading Placeholder:', r)
        }
      }
      const isCancelled = this.itemData.cancelled || (this.originalItem || {}).cancelled
      if (this.readOnly || isCancelled || this.isSaveDisabled || !this.itemData.details || !this.itemData.details[0]) return
      const itemData = this.itemData
      const selectedSeatingTime = this.getSelectedSeatingTime()
      if (!selectedSeatingTime || selectedSeatingTime.disabled) {
        console.log('Skipping placeholder update, No valid seating time selected', placeholder)
        success()
        return
      }
      const placeholder = {
        id: itemData.id,
        // If new item, use selected location/event/date/time
        // If editing, do not change location/event/date/time
        // TODO:  Enforce not changing location/event/date/time for edits on server side.
        locationId: selectedSeatingTime.locationId,
        eventId: selectedSeatingTime.eventId,
        date: itemData.date,
        time: selectedSeatingTime.time,
        covers: this.itemData.details.length,
        recordLockKey: itemData.recordLockKey,
        tableAssignments: itemData.tableAssignments,
      }
      const placeHolderHash = JSON.stringify(placeholder)
      if (placeHolderHash === this.lastPlaceholderHash) {
        console.warn('Already have identical placeholder', placeholder)
        success()
        return
      } else if (!placeholder.locationId) {
        console.warn('Skipping placeholder update, No Location ID', placeholder)
        success()
        return
      } else if (!placeholder.locationId) {
        console.warn('Skipping placeholder update, No Location ID', placeholder)
        success()
        return
      } else if (!placeholder.time) {
        console.warn('Skipping placeholder update, No time selected', placeholder)
        success()
        return
      } else if (!placeholder.date) {
        console.warn('Skipping placeholder update, No date selected', placeholder)
        success()
        return
      } else if (this.forEvent && !placeholder.eventId) {
        console.warn('Skipping placeholder update, No event selected', placeholder)
        success()
        return
      }
      if (this.loadingPlaceholder) {
        console.warn('Already loading placeholder... wait...')
        this.reloadPlaceholder = true
        return
      }
      this.lastPlaceholderHash = placeHolderHash
      this.loadingPlaceholder = true
      this.clearPathErrors(this.jsonPath, 'tableAssignments')
      this.$ftAPI().put(this.addResourceErrorHandler(this.placeHolderCommand(() => {
        console.warn('Loaded Placeholder.  Try again?')
        this.loadingPlaceholder = false
        const runAgain = this.reloadPlaceholder
        this.reloadPlaceholder = false
        if (runAgain) {
          this.getPlaceHolder(success, fail)
        } else {
          this.loadSeatingTimes()
          success()
        }
      }, () => {
        console.error('Failed Loading Placeholder.  Try again?')
        // ??? wtf?
        this.loadingPlaceholder = false
        this.reloadPlaceholder = false
        const runAgain = this.reloadPlaceholder
        this.reloadPlaceholder = false
        if (runAgain) {
          this.getPlaceHolder(success, fail)
        } else {
          if (fail) fail()
        }
      })), placeholder)
    }
  }
}
